




















































































































import Vue from 'vue';
import DropDown from '@/components/FormInputs/DropDown.vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue';

export default Vue.extend({
  name: 'UnternehmenFilters',
  data() {
    return {
      fulltext: '',
    };
  },
  components: {
    DropDown,
    Checkbox,
  },
  methods: {
    setBranche: function(value: number): void {
      this.$store.dispatch('setBranche', value);
    },
    setOrder: function(value: number): void {
      this.$store.dispatch('setOrder', value);
    },
    setBundesland: function(value: number): void {
      this.$store.dispatch('setBundesland', value);
    },
    setBezirk: function(value: number): void {
      this.$store.dispatch('setBezirk', value);
    },
    setFulltext() {
      this.$store.dispatch('setFulltext', this.fulltext);
    },
    setMuttertag(value) {
      this.$store.dispatch('setDynamicFilter', { name: 'muttertag', value });
    },
    setGesichtsmasken(value) {
      this.$store.dispatch('setDynamicFilter', { name: 'gesichtsmasken', value });
    },
    setAktionen(value) {
      this.$store.dispatch('setPresenceFilters', { name: 'aktionen', value });
    },
    setOstergeschenke(value) {
      this.$store.dispatch('setDynamicFilter', { name: 'ostergeschenke', value });
    },
    setOsterjause(value) {
      this.$store.dispatch('setDynamicFilter', { name: 'osterjause', value });
    },
  },
  computed: {
    orders: function() {
      return [
        { name: 'Standard', id: 0 },
        { name: 'Al­pha­be­tisch', id: 1 },
      ];
    },
    order: function() {
      return this.$store.state.order;
    },
    aktionen: function() {
      return this.$store.state.presenceFilters.aktionen || 0;
    },
    gesichtsmasken: function() {
      return this.$store.state.dynamicFilters.gesichtsmasken || 0;
    },
    muttertag: function() {
      return this.$store.state.dynamicFilters.muttertag || 0;
    },
    ostergeschenke: function() {
      return this.$store.state.dynamicFilters.ostergeschenke || 0;
    },
    osterjause: function() {
      return this.$store.state.dynamicFilters.osterjause || 0;
    },
    branchen: function(): Array<string> {
      return [{ name: 'Alle', id: 0 }].concat(this.$store.getters.allBranchen);
    },
    bundeslaender: function(): Array<string> {
      return [{ name: 'Alle', id: 0 }].concat(this.$store.getters.allBundeslaender);
    },
    bezirke: function(): Array<string> {
      return [{ name: 'Alle', id: 0 }].concat(this.$store.getters.getBezirkeForBundesland(this.bundesland));
    },
    branche: function(): string {
      return this.$store.state.branche;
    },
    bundesland: function(): string {
      return this.$store.state.bundesland;
    },
    bezirk: function(): string {
      return this.$store.state.bezirk;
    },
  },
});
